import WResultsSports from './WResultsSports'

export default WResultsSports
